<div class="row space-between gap-8">
    <h2>Edit Image</h2>
    <rr-icon name="close" class="pointer" (click)="close()"></rr-icon>
</div>
<div class="imgcontainer">
    <div class="imgcontainer col">
        <img [src]="imageSrc || ''" alt="" />
    </div>
    <input
        type="file"
        accept="image/*"
        hidden="true"
        #image
        (change)="onFileSelected($event)"
    />
</div>
@if(errorText !== ''){
<div class="color-error w100">
    {{ errorText }}
</div>
}
<div class="row gap-8 space-between w100">
    <div class="col gap-4 align-end">
        <rr-btn
            iconStart="upload"
            size="Medium"
            type="Secondary"
            (click)="image.click()"
            >Upload Image</rr-btn
        >
        <span class="tiny">max filesize 2MB</span>
    </div>
    <div class="row gap-8">
        <rr-btn size="Medium" type="Secondary" (click)="close()">Cancel</rr-btn>
        <rr-btn
            size="Medium"
            type="Primary"
            [disabled]="newFile ? false : true"
            (click)="newFile ? saveNewImage() : null"
            >Save</rr-btn
        >
    </div>
</div>
@if(isLoading==true){
<rr-spinner></rr-spinner>
}

